'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const { string, bool, object, func } = PropTypes

const RoomSelect = createReactClass({
  propTypes: {
    activeRoom: string,
    name: string,
    secondRoomText: string,
    secondRoom: bool,
    RoomTypes: object.isRequired,
    extraOptionText: string,
    changeCallback: func
  },

  getDefaultProps () {
    return {
      activeRoom: 'D20',
      secondRoomText: 'No, thank you',
      secondRoom: false
    }
  },

  makeOption (key, val) {
    return (<option key={val} value={key}>{val}</option>)
  },

  makeOptions () {
    const { RoomTypes } = this.props
    return Object.keys(RoomTypes).map(i => {
      const text = RoomTypes[ i ]
      return this.makeOption(i, text)
    })
  },

  handleChange (e) {
    if (typeof this.props.changeCallback === 'function') {
      this.props.changeCallback(e)
    }
  },

  render () {
    const { secondRoom, secondRoomText, activeRoom, name, extraOptionText } = this.props
    const rooms = this.makeOptions()
    const secondRoomOption = secondRoom && this.makeOption('', secondRoomText)
    const extraOption = extraOptionText && this.makeOption('', extraOptionText)
    const trackName = 'roomtype_' + name.match(/\d+/)[0]
    return (
      <select onChange={this.handleChange} name={name} className='form-control' defaultValue={activeRoom} data-hxtrack-name={trackName}>{secondRoomOption}{extraOption}{rooms}</select>
    )
  }
})

module.exports = RoomSelect



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/engine-horizontal/rooms-dropdown.jsx